import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})

export class CacheService {
  public cache = new Map<string, any>();

  public load(): void {
    this.loadCache();
  }

  public reload(): void {
    this.loadCache(true);
  }

  set(key: string, data: any): void {
    this.cache.set(key, data);
    this.saveCache();
  }

  get(key: string): any {
    const data = this.cache.get(key);
    return data;
  }

  clear(key: string): void {
    this.cache.delete(key);
  }

  private loadCache(reload = false): void {
    if (reload) { sessionStorage.removeItem('cache'); }

    const cached = sessionStorage.getItem('cache');
    if (cached) {
      this.cache = new Map(JSON.parse(cached));
    } 
  }

  private saveCache(): void {
    const cache = Array.from(this.cache.entries()).reverse().splice(0, 100);
    sessionStorage.setItem('cache', JSON.stringify(cache));
  }

}